import ClowncarAppConstants from 'constants/ClowncarAppConstants';

const initialState = {
  events: [],
  baseState: undefined,
  isInitialized: false,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.FETCH_EVENTS_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case ClowncarAppConstants.FETCH_EVENTS_DONE: {
      return {
        ...state,
        events: payload,
        isInitialized: true,
      };
    }
    case ClowncarAppConstants.FETCH_BASE_STATE_DONE: {
      return {
        ...state,
        baseState: payload,
      };
    }
    case ClowncarAppConstants.FETCH_BASE_STATE_FAILED: {
      // Will happen when choosing a topic without a base state.
      return { ...state, baseState: undefined };
    }
    default:
      return state;
  }
}
